import React from "react";

export const MACHINE_SPEED_ALERT_HELP_TITLE = "Alerta de velocidade máxima";

export function MachineSpeedAlertHelpContent() {
  return (
    <>
      <p>
        <strong>Para que serve?</strong> Define a{" "}
        <strong>velocidade máxima recomendada</strong> para esta máquina. Ao
        finalizar um trabalho no app, a plataforma analisa a telemetria do
        período e compara com esse limite.
      </p>

      <p>
        <strong>Quando gera alerta?</strong> Em tempo real, enquanto o
        trabalho está aberto no app — assim que a máquina fica acima do
        limite por tempo relevante. Não é preciso encerrar o turno. Ao
        finalizar, o mesmo alerta permanece na lista até o gestor reconhecer.
      </p>

      <p>
        <strong>Onde aparece?</strong> O alerta é criado{" "}
        <strong>automaticamente</strong> na plataforma web, no menu lateral{" "}
        <strong>Ações pendentes e alertas</strong>, mesmo com a máquina ainda
        em uso, com:
      </p>
      <ul>
        <li>tempo acima do limite;</li>
        <li>percentual do trabalho acima do limite;</li>
        <li>velocidade pico registrada no período.</li>
      </ul>

      <p>
        <strong>WhatsApp (opcional):</strong> se marcar{" "}
        <strong>Enviar alerta de velocidade via WhatsApp</strong>, a mesma
        ocorrência também é enviada ao gestor selecionado. Sem essa opção, o
        alerta fica <strong>somente na plataforma web</strong>.
      </p>

      <p>
        O número deve ser de um <strong>gestor já cadastrado</strong> em
        Administradores (com telefone). Pode haver custo extra por mensagem.
      </p>
    </>
  );
}
